import {
  UserPlus, Target, LayoutDashboard, Kanban, Columns3, ChartNoAxesCombined,
  UsersRound, Settings, ShieldCheck, Hammer, Search, Ruler, HardHat, CheckCircle2,
  BookUser, FileText, CalendarDays, KeyRound, ClipboardList, Inbox, Building2, Globe2,
  BarChart3, Calculator, Boxes, Plug, Coins, Files, FileSignature, Bot, BotMessageSquare, Radar, MessageSquare, Activity, Lightbulb, Sprout, GitCompare, KanbanSquare, Landmark, Presentation,
} from "lucide-react";

export const NAV_GROUPS = [
  {
    label: "CRM",
    items: [
      { to: "/app", label: "Dashboard", icon: LayoutDashboard },
      { to: "/property-intelligence", label: "Land Recon", icon: Globe2, menuKey: "/leads" },
      { to: "/leads", label: "Leads", icon: Inbox, menuKey: "/leads" },
      { to: "/crm?view=pipeline", label: "Kanban Board", icon: Columns3, menuKey: "/leads" },
    ],
  },
  {
    label: "Analysis & Acquisition",
    items: [
      { to: "/property-screening", label: "Property Screening", icon: Search, menuKey: "/leads" },
      { to: "/analysis", label: "Property Analysis", icon: ChartNoAxesCombined, menuKey: "/leads" },
      { to: "/acquisition", label: "Acquisition", icon: KeyRound, menuKey: "/leads" },
    ],
  },
  {
    label: "Development",
    items: [
      { to: "/projects", label: "Projects", icon: Hammer, menuKey: "/leads" },
      { to: "/planning", label: "Planning", icon: ClipboardList, menuKey: "/leads" },
      { to: "/opportunities", label: "Design", icon: Target },
      { to: "/preconstruction", label: "Preconstruction", icon: Ruler, menuKey: "/leads" },
      { to: "/construction", label: "Construction", icon: HardHat, menuKey: "/leads" },
      { to: "/closeout", label: "Closeout", icon: CheckCircle2, menuKey: "/leads" },
    ],
  },
  {
    label: "Operations",
    items: [
      { to: "/decks", label: "Decks", icon: Presentation, menuKey: "/leads" },
      { to: "/buybox", label: "Wholesale Buy Box", icon: Boxes, always: true },
      { to: "/builder-buy-box", label: "Builder Buy Box", icon: Landmark, always: true },
      { to: "/sell-land", label: "QR Code Leads", icon: Coins, always: true },
      { to: "/mail-templates", label: "Mail Templates", icon: Files, always: true },
      { to: "/contracts", label: "Contracts", icon: FileSignature, always: true },
      { to: "/directory", label: "Partners", icon: Building2, menuKey: "/leads" },
      { to: "/partner-contacts", label: "Contacts", icon: BookUser, menuKey: "/leads" },
      { to: "/documents", label: "Documents", icon: FileText, menuKey: "/leads" },
      { to: "/schedule", label: "Schedule", icon: CalendarDays, menuKey: "/leads" },
    ],
  },
  {
    label: "Marketing",
    items: [
      { to: "/ai-office", label: "AI Office", icon: Bot, always: true },
      { to: "/ai-buybox", label: "AI Buy Box", icon: Radar, always: true },
      { to: "/ai-comms", label: "AI Communications", icon: MessageSquare, always: true },
      { to: "/ai-operations", label: "AI Operations", icon: Activity, always: true },
      { to: "/reports", label: "AI Insights", icon: Lightbulb },
    ],
  },
  {
    label: "System",
    items: [
      { to: "/team", label: "Team", icon: UsersRound },
      { to: "/calculations", label: "Calculations", icon: Calculator, always: true },
      { to: "/contact-requests", label: "Contact Requests", icon: Inbox, adminOnly: true },
      { to: "/integrations", label: "Integrations", icon: Plug, adminOnly: true },
      { to: "/mapping/propertyradar", label: "PR Field Mapping", icon: GitCompare, adminOnly: true },
      { to: "/mapping/realestateapi", label: "REAPI Field Mapping", icon: GitCompare, adminOnly: true },
      { to: "/lead-import-template", label: "Lead Import Template", icon: Files, adminOnly: true },
      { to: "/roles", label: "Access Control", icon: ShieldCheck, adminOnly: true },
      { to: "/settings", label: "Settings", icon: Settings },
    ],
  },
];
